import React from 'react';
import PropTypes from 'prop-types';
import { ExpiryAlertIcon } from './ExpiryAlertIcon';
import { VALIDITY_STATUS, formatCalendarDate } from '../../../helpers/ExpiryRule';

export const formatMaintenanceExpiringMessage = (daysLeft) => {
	return `Maintenance expiring in ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}.`;
};

// The date shown and the value the column sorts on are the same one (`row.expirationDate`).
export const ExpirationDateCell = ({ calendarDate, expiringInDays }) => {
	if (!calendarDate) {
		return null;
	}

	const formattedDate = formatCalendarDate(calendarDate);

	if (expiringInDays === null) {
		return formattedDate;
	}

	return (
		<div className="d-flex align-items-center">
			<span className="me-2">{formattedDate}</span>
			<ExpiryAlertIcon status={VALIDITY_STATUS.EXPIRING} text={formatMaintenanceExpiringMessage(expiringInDays)} />
		</div>
	);
};

ExpirationDateCell.propTypes = {
	calendarDate: PropTypes.string,
	expiringInDays: PropTypes.number,
};

ExpirationDateCell.defaultProps = {
	calendarDate: null,
	expiringInDays: null,
};
